import { render } from "./AreaCreateStandard.vue?vue&type=template&id=06ecbe38&scoped=true"
import script from "./AreaCreateStandard.vue?vue&type=script&lang=js"
export * from "./AreaCreateStandard.vue?vue&type=script&lang=js"

import "./AreaCreateStandard.vue?vue&type=style&index=0&id=06ecbe38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ecbe38"]])

export default __exports__